<template>
  <div class="flex justify-center align-middle min-h-screen overflow-x-hidden
    bg-center bg-fixed bg-repeat py-8 px-4 sm:py-12 sm:px-6 md:py-20 md:px-12 lg:py-28 lg:px-16 items-center">
    <div class="w-full max-w-[36rem]">
      <router-view/>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AuthView',
};
</script>
